import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";

const SCVMasterData = () => {
  const headers = [
    "zone",
    "circle",
    "vehicleNumber",
    "vehicleUid",
    "collectionType",
    "vehicleType",
    "ownerType",
    "contractorName",
    "status",
  ];
  const [isLoading, setIsLoading] = useState(false);

  const searchResults = require("../../../Common/Json/scvMasterData.json");

  useEffect(() => {
    // Simulate loading data
    setIsLoading(true);

    // Assuming you have an asynchronous data fetching process
    fetchData()
      .then(() => setIsLoading(false)) // Once data fetching is done, set isLoading to false
      .catch((error) => {
        setIsLoading(false); // Set isLoading to false in case of error
        console.error("Error fetching data:", error);
        // Handle error (e.g., show error message)
      });
  }, []); // Empty dependency array means this effect runs only once on mount

  // Function to simulate asynchronous data fetching
  const fetchData = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              {/* <h4 style={{ display: "flex", marginTop: "30px" }}>
                SCVs Master Data Report
              </h4> */}
            </div>
            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span > SCVs Master Data Report</span>
                </div>
                <TableComponent isLoading={isLoading}
                  DataFetchURL={searchResults}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                // editData={handleEditShift} // Pass the callback function
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SCVMasterData;
